import { useEffect, useState } from "react";

function App() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetch("https://lghrequests.com/api/orders")
      .then(res => res.json())
      .then(data => setOrders(data));
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <h1>📦 LINE Orders Dashboard</h1>

      {orders.map(order => (
        <div key={order.id} style={{
          padding: 10,
          margin: 10,
          border: "1px solid #ccc",
          borderRadius: 8
        }}>
          <div><b>ID:</b> {order.id}</div>
          <div><b>Text:</b> {order.text}</div>
          <div><b>Status:</b> {order.status}</div>
        </div>
      ))}
    </div>
  );
}

export default App;